import { createEntityAdapter } from '@reduxjs/toolkit';
import { Vehicle } from '../../../types/vehicle';
import apiSlice from '..';
import { EntityWithCount } from '../types';
import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/dist/query';

type VehicleHistoryQueryArgs = {
  [x: string]: any;
};

export const adminVehicleHistoryAdapter = createEntityAdapter<Vehicle>({});

export const adminVehicleHistoryApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAdminVehicles: builder.query<EntityWithCount<Vehicle>, VehicleHistoryQueryArgs>({
      query: ({ limit, offset, ...filters }) => ({
        url: `/admin/vehicles`,
        method: 'GET',
        params: {
          limit,
          offset,
          ...filters
        }
      }),
      providesTags: ['VehicleHistory'],
      transformResponse: (response: any) => {
        return {
          rows: adminVehicleHistoryAdapter.addMany(adminVehicleHistoryAdapter.getInitialState(), response.data.rows),
          count: Number(response.data.count)
        };
      },
      serializeQueryArgs: ({ endpointName, queryArgs, endpointDefinition }) => {
        const { offset, ...restArgs } = queryArgs;
        return defaultSerializeQueryArgs({ queryArgs: restArgs, endpointDefinition, endpointName });
      },
      merge: (currentCache, newItems, { arg, baseQueryMeta }) => {
        const newVehicles = (newItems.rows?.ids?.map(el => newItems.rows.entities[el]) ?? []) as Vehicle[];
        currentCache.count = newItems.count;
        if (arg.offset === 1) {
          adminVehicleHistoryAdapter.setAll(currentCache.rows, newVehicles);
        } else {
          adminVehicleHistoryAdapter.addMany(currentCache.rows, newVehicles);
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.offset !== previousArg?.offset;
      }
    }),
    syncBlueDriverVehicles: builder.mutation<void, void>({
      query: () => ({
        url: `vehicles/bluedriver/sync`,
        method: 'POST'
      }),
    })
  }),
  overrideExisting: true
});

export const { useGetAdminVehiclesQuery, useSyncBlueDriverVehiclesMutation } = adminVehicleHistoryApiSlice;
